import React from 'react';
import { useParams } from 'react-router-dom';
import './digitalMarketing.css';
import digitalMarketingData from './digitalMarketingData';

const DigitalMarketingTemplate = () => {

  const { slug } = useParams();

  const project = digitalMarketingData.find(
    item => item.slug === slug
  );

  if (!project) {
    return <h1>Project Not Found</h1>;
  }

  return (

    <div className="dm-page">

      {/* HERO */}

      <section className="dm-hero">

        <div className="dm-hero-left">

          

          <div className="dm-badge">
            DIGITAL MARKETING
          </div>

          <h1>{project.title}</h1>

          <p>
            {project.heroDesc}
          </p>

          <div className="dm-info-row">

            <div className="dm-info-box">

              <div className="dm-info-icon">🏭</div>

              <div>
                <span>Industry</span>
                <h4>{project.industry}</h4>
              </div>

            </div>

            <div className="dm-info-box">

              <div className="dm-info-icon">📈</div>

              <div>
                <span>Services</span>
                <h4>{project.service}</h4>
              </div>

            </div>

          </div>

          

        </div>

        <div className="dm-hero-right">

          <img
            src={project.heroImage}
            alt={project.title}
          />

        </div>

      </section>

      {/* ABOUT + APPROACH */}

      <section className="dm-middle-grid">

        <div className="dm-about-card">

          <h2>About the Project</h2>

          <p>
            {project.about}
          </p>



        </div>

        {/* APPROACH */}

        <div className="dm-approach-card">

          <h2>Our Approach</h2>

          <div className="dm-approach-steps">

            {project.approach.map((step, index) => (

              <React.Fragment key={index}>

                <div className="approach-step">

                  <div className="step-icon">
                    {step.icon}
                  </div>

                  <h4>{step.title}</h4>

                  <span>{step.desc}</span>

                </div>

                {index !== project.approach.length - 1 && (
                  <div className="step-line"></div>
                )}

              </React.Fragment>

            ))}

          </div>

        </div>

      </section>

      {/* WHAT WE DID */}

      <section className="dm-services-section">

        <h2>What We Did</h2>

        <div className="dm-title-line"></div>

        <div className="dm-services-grid">

          {project.servicesDone.map((item, index) => (

            <div className="dm-service-card" key={index}>

              <div className="service-icon">
                {item.icon}
              </div>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

            </div>

          ))}

        </div>

      </section>

      {/* POSTS */}

      <section className="dm-posts-section">

        <h2>Some Posts We Created</h2>

        <div className="dm-title-line"></div>

        <div className="dm-posts-grid">

          {project.posts.map((post, index) => (

            <img
              key={index}
              src={post}
              alt=""
            />

          ))}

        </div>

      </section>

      {/* IMPACT */}

      <section className="dm-impact-grid">

        <div className="dm-impact-box">

          <h2>The Impact</h2>

          <ul>

            {project.impact.map((item, index) => (
              <li key={index}>✔ {item}</li>
            ))}

          </ul>

        </div>

        {/* TESTIMONIAL */}

        <div className="dm-testimonial">

          <div className="quote-mark">“</div>

          <p>
            {project.testimonial}
          </p>

          <div className="testimonial-user">

            <h4>{project.testimonialName}</h4>

            <span>{project.testimonialRole}</span>

          </div>

        </div>

      </section>

      

    </div>

  );

};

export default DigitalMarketingTemplate;